import { apiGet } from 'helpers/ApiHelper';
import Auth from 'j-toker';

export function getContactPortalLead() {
  return apiGet(`${Auth.getApiUrl()}/leads/contact_portal/lead`);
}
